import { AllieIconProps } from '../../../components';

export const MessageQuestionCircleIcon: React.FC<AllieIconProps> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    className={`stroke-icon ${className}`}
  >
    <path
      // eslint-disable-next-line max-len
      d="M8.74973 7.50186C8.89656 7.08447 9.18637 6.7325 9.56784 6.50831C9.94931 6.28412 10.3978 6.20217 10.8339 6.27697C11.27 6.35177 11.6656 6.57851 11.9505 6.917C12.2355 7.2555 12.3914 7.68393 12.3908 8.1264C12.3908 9.37547 10.5172 10 10.5172 10M10.5413 12.5H10.5496M10.4164 16.6667C14.3284 16.6667 17.4997 13.4953 17.4997 9.58333C17.4997 5.67132 14.3284 2.5 10.4164 2.5C6.50438 2.5 3.33306 5.67132 3.33306 9.58333C3.33306 10.375 3.46293 11.1363 3.70254 11.8472C3.7927 12.1147 3.83779 12.2484 3.84592 12.3512C3.85395 12.4527 3.84788 12.5238 3.82277 12.6225C3.79735 12.7223 3.74122 12.8262 3.62897 13.034L2.26593 15.557C2.0715 15.9168 1.97429 16.0968 1.99604 16.2356C2.01499 16.3566 2.08618 16.4631 2.19071 16.5269C2.31071 16.6001 2.51414 16.579 2.92101 16.537L7.18853 16.0958C7.31777 16.0825 7.38238 16.0758 7.44128 16.0781C7.49921 16.0803 7.5401 16.0857 7.59659 16.0987C7.65402 16.112 7.72625 16.1398 7.87069 16.1954C8.66073 16.4998 9.51908 16.6667 10.4164 16.6667Z"
      stroke={props.allieColor || '#CECFD2'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
